import { Sizes } from "../constants/size";
import type { IconProps } from "../types/icon-props";

export const Filmzi = (props: IconProps) => {
  const {
    size = "md",
    fill = "var(--grey-1)",
    stroke = "var(--grey-1)",
    ...rest
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 24 20"
      fill="none"
      {...rest}
    >
      <path
        d="M13.2102 13.3336H7.6102C7.43628 13.3336 7.29715 13.1945 7.29715 13.0206V6.98003C7.29715 6.80612 7.15803 6.66699 6.98411 6.66699H2.72906C2.54356 6.66699 2.36965 6.73656 2.24211 6.87569L0.989944 8.12785C0.862409 8.25539 0.78125 8.44089 0.78125 8.61481V19.6872C0.78125 19.8611 0.92038 20.0002 1.09429 20.0002H7.16962L7.38991 19.9075L8.44497 18.8524L10.1145 17.1829L13.4305 13.867C13.6276 13.6699 13.4884 13.3336 13.2102 13.3336ZM2.40443 8.99741C2.40443 8.77713 2.58994 8.59162 2.81022 8.59162H5.21021C5.21021 8.59162 5.25659 8.59162 5.26818 8.60321C5.47688 8.6264 5.61601 8.80031 5.61601 8.99741V10.7018H2.40443V8.99741ZM5.61601 12.1858V14.2959H2.40443V12.1858H5.61601ZM2.40443 17.4727V15.7684H5.61601V17.4727C5.61601 17.7046 5.44209 17.8785 5.21021 17.8785H2.81022C2.58994 17.8785 2.40443 17.7046 2.40443 17.4727Z"
        fill="#AFAFB6"
      />
      <path
        d="M10.7912 6.66663H16.3912C16.5651 6.66663 16.7042 6.80576 16.7042 6.97967V13.0202C16.7042 13.1941 16.8433 13.3333 17.0173 13.3333H21.2723C21.4578 13.3333 21.6317 13.2637 21.7593 13.1246L23.0114 11.8724C23.139 11.7449 23.2201 11.5594 23.2201 11.3854V0.313042C23.2201 0.13913 23.081 0 22.9071 0H16.8317L16.6115 0.0927531L15.5564 1.14782L13.8868 2.81738L10.5709 6.1333C10.3738 6.3304 10.5129 6.66663 10.7912 6.66663ZM21.5969 11.0028C21.5969 11.2231 21.4114 11.4086 21.1911 11.4086H18.7912C18.7912 11.4086 18.7448 11.4086 18.7332 11.397C18.5245 11.3738 18.3854 11.1999 18.3854 11.0028V9.2985H21.5969V11.0028ZM18.3854 7.81445V5.70432H21.5969V7.81445H18.3854ZM21.5969 2.52752V4.23186H18.3854V2.52752C18.3854 2.29564 18.5593 2.12173 18.7912 2.12173H21.1911C21.4114 2.12173 21.5969 2.29564 21.5969 2.52752Z"
        fill="#AFAFB6"
      />
    </svg>
  );
};

Filmzi.displayName = "Filmzi";
